/// "Paket süresi dışında" (Aşkın msg 367): ders öğrencinin paket
/// bitişinden sonraya planlanmışsa sunucu `afterCreditExpiry` basar;
/// listede satır soluk görünür, yanında rozet çıkar. İptal edilmiş ders
/// zaten hak düşmez, işaretlenmez (mobil `lesson_card.dart` ile aynı kural).

export const OUT_OF_PACKAGE_LABEL = 'Paket süresi dışında';

export function isOutOfPackageLesson(lesson: { afterCreditExpiry?: boolean; status?: string }): boolean {
  return lesson.afterCreditExpiry === true && lesson.status !== 'cancelled';
}
